import { createFileRoute } from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {PERMISSIONS, ROLES} from "@/lib/auth/roles";
import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import RiskAndOpportunitySettings from "@/modules/risk-and-opportunity-settings";
import {riskSettingsQueryOptions} from "@/modules/risk-and-opportunity-settings/hooks";
import {
  mergedRiskAndOpportunitySettingsSearchSchema,
  RiskAndOpportunitySettingsSearch,
} from "@/types/route-search-schemas";
import {DataLoader} from "@/types/router-context";
import {
  RISK_AND_OPPORTUNITY_SETTINGS_PATH,
  RISK_AND_OPPORTUNITY_SETTINGS_URL
} from "@/utils/urls";

export const Route = createFileRoute(RISK_AND_OPPORTUNITY_SETTINGS_PATH)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): RiskAndOpportunitySettingsSearch => validateSearchWithDefaults(mergedRiskAndOpportunitySettingsSearchSchema, search),
  loader: ({ context: { queryClient } }: DataLoader) => {
    if (isCurrentPage(RISK_AND_OPPORTUNITY_SETTINGS_URL)) {
      return
    }
    queryClient.prefetchQuery(riskSettingsQueryOptions())
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Risks and opportunities', path: '#' },
        { label: 'Settings', path: '/' }
      ],
      children: null
    }
  },

})

function RouteComponent() {
  return (
    <div className='flex flex-col items-center justify-center p-8 sm:p-0'>
      <Authorisation roles={[ROLES.ROLE_ELEVATION]} permissions={[PERMISSIONS.CAN_EDIT_RISKS_AND_OPPORTUNITIES]} forbiddenFallback={<Unauthorized/>}>
        <RiskAndOpportunitySettings/>
      </Authorisation>
    </div>
  )
}
